import { __assign } from "tslib";
import { formatMessage, formatMessageToParts } from './formatMessage';
import { getMessageFormatter } from './formatters';
import { getPreferences, formatEmployeeName, formatEmployeeNameSalutation } from './utils';
/**
 * Creates intl message formatter functions
 */
export function createIntlLite(_pref, customFormatters) {
    if (customFormatters === void 0) { customFormatters = {}; }
    var preferences = getPreferences(_pref);
    var formatters = { getMessageFormatter: getMessageFormatter, preferences: preferences };
    return __assign({ preferences: preferences, formatMessage: formatMessage.bind(null, formatters), formatMessageToParts: formatMessageToParts.bind(null, formatters), translate: formatMessage.bind(null, formatters), 
        // Export these to remain consistent with nui-intl
        formattedMessage: formatMessage.bind(null, formatters), formatEmployeeName: formatEmployeeName.bind(null, formatters), formatEmployeeNameSalutation: formatEmployeeNameSalutation.bind(null, formatters) }, customFormatters);
}
